module.exports = __webpack_public_path__ + "static/img/pricing.2ada3a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pricing.png
// module id = DsQC
// module chunks = 0